import Stack from '@mui/material/Stack';
import IntercomSupport from 'src/components/intercom/intercom';
import Logo from 'src/components/logo';

import Footer from '../main/footer';

type Props = {
  children: React.ReactNode;
  width?: number | string;
  disabledLink?: boolean;
};

export default function AuthClassicLayout({ children, width, disabledLink }: Props) {
  const renderLogo = (
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2 }}>
      <Logo
        sx={{
          my: { xs: 2, md: 3 },
          mx: { xs: 0, md: 3 },
        }}
        disabledLink={disabledLink ?? false}
      />
      <IntercomSupport />
    </Stack>
  );

  const renderContent = (
    <Stack
      sx={{
        width: 1,
        mx: 'auto',
        maxWidth: width || 480,
        px: { xs: 2, md: 8 },
        pt: { xs: 2, md: 2 },
      }}
    >
      {children}
    </Stack>
  );

  return (
    <Stack
      component="main"
      direction="column"
      sx={{
        minHeight: '100vh',
      }}
    >
      {renderLogo}
      {renderContent}
      <Footer noTabbar />
    </Stack>
  );
}
